import React, { useCallback } from "react";
// import { openGalleryModalSlice } from "@/reduxtoolkit/slices/global.slice";
import { openGalleryModalSlice } from "../../../../redux-toolkit/slices/global.slice";
// import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppDispatch } from "../../../../hooks/useAppDispatch";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import styles from "@/styles/pages/home.module.scss";
import styles from "../../../../styles/pages/home.module.scss";
// import styles1 from "@/styles/components/dashboardTable.module.scss";
import styles1 from "../../../../styles/components/dashboardTable.module.scss";
// import Image from "next/image";
// import assest from "@/json/assest";
import assest from "../../../../json/assest";
import Pagination from "../../../UtilitiesComponent/Pagination";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDateTime,
  getUtcTime,
  roleFinder,
} from "../../../../lib/functions/utils.lib";
import PaginationTwo from "../../../UtilitiesComponent/PaginationTwo";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import NoResultTwo from "../../../NoResult/NoResultTwo";
import Filter from "../../../Filter/Filter";
import { useState } from "react";
import VideoPageFullModal from "../../../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../../../VideoPages/pages/WatchVideoModal";

export default function DashboardModalVideosTable(props) {
  const {
    hideConfirmedByCol,
    confirmedByColName,
    hideApprovedByCol,
    approvedByColName,
    datas,
    handlePageChange,
    page,
    filtersReset,
    filterActive,
    handleTriggreFetch,
    loading,
  } = props;
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };
  const dispatch = useAppDispatch();
  const handleClickOpenGalleryModal = useCallback(() => {
    dispatch(openGalleryModalSlice());
  }, []);

  const [openModalTwo, setOpenModalTwo] = useState(false);

  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };
  return (
    <>
      <Box className={styles1.dashboardAllTables}>
        {/* <PerfectScrollbar
          className={`${
            datas?.data.length > 0 ? styles1.withHeight : styles1.withoutHeight
          }`}
        > */}
          <TableContainer
            component={Paper}
            className={`${styles1.table_main_childrnwrp}`}
          >
            <Table
              className={`${styles1.dashboardTable} ${styles1.dashboardTableInners}`} stickyHeader aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell className={styles1.vsid}>VSID</TableCell>
                  <TableCell className={styles1.acqui}>Acquisitor</TableCell>
                  <TableCell className={styles1.thumb}>Thumbnail</TableCell>
                  <TableCell className={styles1.title}>Title</TableCell>
                  <TableCell className={styles1.submitter}>
                    Submitter Name
                  </TableCell>
                  <TableCell className={styles1.email}>Email Address</TableCell>
                  <TableCell className={styles1.submission}>
                    Submission Date
                  </TableCell>
                  {!hideApprovedByCol ? (
                    <TableCell className={styles1.approve}>
                      {approvedByColName}
                    </TableCell>
                  ) : null}
                  {!hideConfirmedByCol ? (
                    <TableCell className={styles1.confirm}>
                      {confirmedByColName}
                    </TableCell>
                  ) : null}
                  <TableCell className={styles1.view}>View</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {/* {rows.map((row) => ( */}
                {datas?.data.map((row) => (
                  <>
                    <TableRow key={row.id}>
                      <TableCell>
                        <Box className={styles.vsid_code}>
                          {/* <img
                                                src={assest.infoicon}
                                                width={3}
                                                height={18}
                                                alt=""
                                            />{" "} */}
                          <p>{row.id}</p>
                          {row.unseen_messages ? (
                            <span className={styles.vsid_circ}></span>
                          ) : (
                            <></>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className={styles.acquisitor}>
                          {row.user?.name} {row.user?.last_name}
                          <p className={styles.table_customer}>
                            {roleFinder(row.user?.role_id)}
                          </p>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Button onClick={() => onOpenTwo(row.id)}>
                          <figure className={styles.thumb_img}>
                            <img
                              className={styles.thumb_img}
                              src={concatHostAndImagePath(row.thumbnail)}
                            />
                          </figure>
                        </Button>
                      </TableCell>
                      <TableCell>{row.title}</TableCell>
                      <TableCell>
                        {row.first_name} {row.last_name}
                      </TableCell>
                      <TableCell>
                        {row.email}
                        {row.unreachable_submitter ? (
                          <p className={styles.red_email}>Unreachable Email</p>
                        ) : (
                          <></>
                        )}
                      </TableCell>
                      <TableCell>
                        {getUtcDate(row.created_at)} <br />{" "}
                        {getUtcTime(row.created_at)}
                      </TableCell>
                      <TableCell className={styles1.inquirerBoxActive}>
                        <Box className={styles1.inquirerBox}>
                          {row.manager?.name}
                          <br /> <span>Manager</span> 
                          <span className={styles1.inqr_spntable}>
                            {" "}
                            {row.video_meta.manager_updated_at
                              ? ` ${getUtcDateTime(
                                  row.video_meta.manager_updated_at
                                )}`
                              : ""}
                          </span>
                        </Box>
                      </TableCell>
                      <TableCell className={styles1.inquirerBoxActive}>
                        <Box className={styles1.inquirerBox}>
                          {row.quality_team?.name}
                          <br /> <span>QC Agent</span>
                          <span className={styles1.inqr_spntable}>
                            {" "}
                            {row.video_meta.quality_team_updated_at
                              ? ` ${getUtcDateTime(
                                  row.video_meta.quality_team_updated_at
                                )}`
                              : ""}
                          </span>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className={styles.table_view}>
                          <Button onClick={() => onOpen(row.id)}>
                            <img
                              src={assest.tableview}
                              width={16}
                              height={16}
                              alt=""
                            />
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>

                    <TableRow className={styles.blnkTd}>
                      <TableCell colSpan={10}>{""}</TableCell>
                    </TableRow>
                  </>
                ))}
                <TableRow className={styles.paginationTble}>
                  <TableCell colSpan={10} sx={{ border: "none !important" }}>
                    {datas?.data.length > 0 ? (
                      <>
                        {datas.data.length < datas.per_page &&
                        datas.last_page == 1 ? (
                          <>
                            <p className={styles.endList}>
                              End of list. We couldn't find more videos that
                              match your selected filter(s).
                            </p>
                          </>
                        ) : (
                          <>
                            <PaginationTwo
                              page={page}
                              count={datas?.last_page}
                              handleChange={handlePageChange}
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        {/* </PerfectScrollbar> */}
        <VideoPageFullModal
          onClose={onClose}
          open={openModal}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
        <WatchVideoModal
          onClose={onCloseTwo}
          open={openModalTwo}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
        {datas?.data.length > 0 ? (
          <></>
        ) : (
          <>
            {filterActive ? (
              <Filter resetFilters={filtersReset} />
            ) : (
              <>{!loading && <NoResultTwo heading="unreach" />}</>
            )}
          </>
        )}
      </Box>
    </>
  );
}
